import PropTypes from 'prop-types';

import styles from './MobileTitleSection.module.scss';

/**
 * 모바일 제목 섹션 컴포넌트
 * - 문서 제목 표시
 */
function MobileTitleSection({ title }) {
  return (
    <div className={styles.container}>
      <h3 className={styles.sectionTitle}>제목</h3>
      <div className={styles.titleContent}>
        <div className={styles.titleBox}>
          <span className={styles.titleText}>{title || '-'}</span>
        </div>
      </div>
    </div>
  );
}

MobileTitleSection.propTypes = {
  title: PropTypes.string,
};

MobileTitleSection.defaultProps = {
  title: '',
};

export default MobileTitleSection;
